import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import * as UTIL from '../../util';
import { apiUtil } from '../../util';
var Creators = Actions.Creators;
var pageChangeArticle = Creators.pageChange;
var yearChangeArticle = Creators.yearChange;
var pageSizeChangeArticle = Creators.pageSizeChange;
var sourceChangeArticle = Creators.sourceChange;
var requestArticles = Creators.request;
var receiveArticles = Creators.response;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

function fetchArticles(state) {
  return function (dispatch) {
    var _state$article, _state$article2, _state$article3, _state$article4;

    dispatch(requestArticles());
    var year = ((_state$article = state.article) === null || _state$article === void 0 ? void 0 : _state$article.filterYear) ? "year=".concat(state.article.filterYear, "&") : "";
    var currentPage = isNaN((_state$article2 = state.article) === null || _state$article2 === void 0 ? void 0 : _state$article2.currentPage) ? "" : "currentPage=".concat(state.article.currentPage, "&");
    var pageSize = ((_state$article3 = state.article) === null || _state$article3 === void 0 ? void 0 : _state$article3.pageSize) ? "pageSize=".concat(state.article.pageSize, "&") : "";
    var dataSource = ((_state$article4 = state.article) === null || _state$article4 === void 0 ? void 0 : _state$article4.dataSource) ? "datasource=".concat(state.article.dataSource) : ""; //Default datasource &datasource={AB5C8EFA-958B-40E8-A408-1CE312148382}

    if (dataSource) {
      var params = "".concat(year).concat(currentPage).concat(pageSize).concat(dataSource);
      return UTIL.apiUtil.fetchGet("".concat(apiUtil.API.getArticles, "?").concat(params)).then(function (json) {
        var pascal = UTIL.toPascal(json);
        dispatch(receiveArticles(pascal));
      }).catch(function (err) {
        dispatch(receiveError(UTIL.buildError(err)));
      });
    }
  };
}

var getArticles = function getArticles(pageNumber) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(pageChangeArticle({
      currentPage: pageNumber || state.currentPage
    }));
    return dispatch(fetchArticles(getState()));
  };
};

var setYear = function setYear(filterYear) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(yearChangeArticle({
      filterYear: filterYear || state.filterYear
    }));
    return dispatch(fetchArticles(getState()));
  };
};

var setPageSize = function setPageSize(pageSize) {
  return function (dispatch) {
    return dispatch(pageSizeChangeArticle({
      pageSize: pageSize
    }));
  };
};

var setDataSource = function setDataSource(dataSource) {
  return function (dispatch, getState) {
    dispatch(sourceChangeArticle({
      dataSource: dataSource
    }));
    return dispatch(fetchArticles(getState()));
  };
};

export default {
  fetchArticles: fetchArticles,
  getArticles: getArticles,
  receiveError: receiveError,
  receiveArticles: receiveArticles,
  setYear: setYear,
  setPageSize: setPageSize,
  setDataSource: setDataSource
};